
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';
import { DialogType, MediDialogComponent } from './medi-dialog/medi-dialog.component';
import { Observable } from 'rxjs';

const httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

// Only the two fields setRatenplan/saveRatenplan touch; callers pass richer objects.
export interface RatenplanPayload {
    ErsteRate?: moment.MomentInput;
    Raten?: unknown[];
}

export class HttpRequestOro {
    Url: string;
    Headers: HttpHeaders;

    constructor(url: string, headers: HttpHeaders) {
        this.Url = url;
        this.Headers = headers;
    }
}

@Injectable()
export class OroService {
    public visible: boolean = true;
    baseUrl = environment.apiUrl;
    authServiceUrl = environment.authServiceUrl;
    apiKey = environment.apiKey;
    router: Router;
    dossierinfo: Record<string, unknown> = {};
    mode = 0;
    Token: string = "";
    tokenResponse: Record<string, unknown> = {};
    clientName: string = "OroWebSchupo";
    clientVersion: string = "1.0.0.0";

    public DateMask = {
        guide: true,
        showMask : false,
        mask: [/\d/, /\d/, '.', /\d/, /\d/, '.',/\d/, /\d/,/\d/, /\d/]
      };

    constructor(private http: HttpClient, private _router: Router, private route: ActivatedRoute, public cookieservice: CookieService, public dialog: MatDialog) {
        this.router = _router;
    }

    ChangeDate(date: Date | string | null): Date | null {
        console.log('ChangeDate input:', date);

        if (!date) {
          return null;
        }

        if (date instanceof Date) {
          return date;
        }

        if (typeof date === 'string') {
          const momentDate = moment(date, 'DD.MM.YYYY', true);
          if (momentDate.isValid()) {
            return momentDate.toDate();
          }
        }

        return null;
      }

    setUberzahlung(ueberzahlung: Object) {
        return this.postElement('schupo/ueberzahlung', ueberzahlung);
    }

    getUberzahlung() {
        return this.getElement('schupo/ueberzahlung');
    }

    uberzahlungRequest() {
        return this.getElement('schupo/ueberzahlung/request');
    }

    setRatenplan(ratenplan: RatenplanPayload) {
        if (ratenplan.ErsteRate) {
            ratenplan.ErsteRate = moment(ratenplan.ErsteRate, 'DD.MM.YYYY');
        }

        ratenplan.Raten = [];

        return this.postElement('schupo/ratenplan/berechnen', ratenplan);
    }

    saveRatenplan(ratenplan: RatenplanPayload) {
        if (ratenplan.ErsteRate) {
            ratenplan.ErsteRate = moment(ratenplan.ErsteRate, 'DD.MM.YYYY');
        }

        ratenplan.Raten = [];
        return this.postElement('schupo/ratenplan/save', ratenplan);
    }

    DownloadRatenplan(ratenplan: Object) {
        return this.postElementDownload('schupo/ratenplan/download', ratenplan);
    }

    saveDirektzahlung(direktzahlung: Object) {
        return this.postElement('schupo/direktzahlung', direktzahlung);
    }

    getDossierInfo() {
        return this.getElement('schupo/dossierinfo', true);
    }

    setLogin(token: string) {
        return this.postElementLogin(false, 'schupouser/login', { token });
    }

    getLoginStatus() {
        this.getElementLoginCheck("schupouser/login/check")
            .catch((error: unknown) => console.error('getLoginStatus => error:', error));
    }

    setLogout() {
        // user spezifischen Cookie löschen (invalidate)
        this.postElementLogout('schupouser/logout')
            .catch((error: unknown) => console.error('setLogout => error:', error));
        this.Token = "";
    }

    getElement(apifunction: string, isnavelement = false) {
        const request: HttpRequestOro = this.prepareHttpRequest(apifunction);
        return this.http.get(request.Url, { withCredentials: true, headers: request.Headers })
            .toPromise()
            .then(
                res => { // Success
                    return res;
                }
            ).catch((error: HttpErrorResponse) => {
                return this.handleerror(error);
            });
    }

    isEmptyObject(obj) {
        return (obj === undefined || obj == null || obj && (Object.keys(obj).length === 0));
    }

    getElementbyId(apifunction: string, Id: number) {
        const request: HttpRequestOro = this.prepareHttpRequest(apifunction + "?Id=" + Id);
        return this.http.get(request.Url, { withCredentials: true, headers: request.Headers })
            .toPromise()
            .then(
                res => { // Success
                    return res;
                }
            ).catch((error: HttpErrorResponse) => {
                return this.handleerror(error);
            });
    }

    getElementFreeUrl(apifunction: string, freeurl: string) {
        const request: HttpRequestOro = this.prepareHttpRequest(apifunction + freeurl);
        return this.http.get(request.Url, { withCredentials: true, headers: request.Headers })
            .toPromise()
            .then(
                res => { // Success
                    return res;
                }
            ).catch((error: HttpErrorResponse) => {
                return this.handleerror(error);
            });
    }

    putElement(apifunction: string, param: unknown) {
        const request: HttpRequestOro = this.prepareHttpRequest(apifunction);
        let body = JSON.stringify(param);
        return this.http.put(request.Url, body, { withCredentials: true, headers: request.Headers })
            .toPromise()
            .then(
                res => { // Success

                    return res;
                }
            ).catch((error: HttpErrorResponse) => {
                return this.handleerror(error);
            });
    }

    deleteElement(apifunction: string, id: string) {
        const request: HttpRequestOro = this.prepareHttpRequest(apifunction);
        return this.http.delete(request.Url + "?id=" + id, { withCredentials: true, headers: request.Headers })
            .toPromise()
            .then(
                res => { // Success
                    return res;
                }
            ).catch((error: HttpErrorResponse) => {
                return this.handleerror(error);
            });
    }

    postElement(apifunction: string, O: Object) {
        const request: HttpRequestOro = this.prepareHttpRequest(apifunction);
        return this.http.post(request.Url, O, { withCredentials: true, headers: request.Headers })
            .toPromise()
            .then(
                res => { // Success

                    return res;
                }
            ).catch((error: HttpErrorResponse) => {
                return this.handleerror(error);
            });
    }

    postElementDownload(apifunction: string, O: unknown) {
        const request: HttpRequestOro = this.prepareHttpRequest(apifunction);
        return this.http.post(request.Url, O, { withCredentials: true, responseType: 'blob' as 'json' })
            .toPromise()
            .then(
                Response => { // Success

                    return this.downloadFile(Response as unknown as Blob);
                }
            ).catch((error: HttpErrorResponse) => {
                return this.handleerror(error);
            });
    }

    downloadFile(data: Blob) {
        const blob = new Blob([data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);

        window.open(url, "_blank");
        return url;
    }

    postFile(apifunction: string, O: FormData) {
        const request: HttpRequestOro = this.prepareHttpRequest(apifunction);
        return this.http.post(request.Url, O, { withCredentials: true, headers: request.Headers })
            .toPromise()
            .then(
                res => { // Success
                    return res;
                }
            ).catch((error: HttpErrorResponse) => {
                return this.handleerror(error);
            });
    }

    getElementLoginCheck(apifunction: string, isnavelement = false) {
        let apiURL = this.authServiceUrl + apifunction;
        const language = this.cookieservice.get('lang');

        return this.http.get(apiURL, {
            withCredentials: true, headers: {
                'lang': language,
                'client': this.clientName,
                'version': this.clientVersion,
                'ApiKeyOroSchupo': this.apiKey
            }
        })
            .toPromise()
            .then(
                res => { // Success
                    return 'sucess';
                }
            ).catch((error: HttpErrorResponse) => {
                console.log('getElementLoginCheck => error: ' + error.error.Caption.toString());
                window.location.href = "/?Logout=1";
                return this.handleerror(error);
            });
    }

    postElementLogin(wartung: boolean, apifunction: string, O: Object) {
        const request: HttpRequestOro = this.prepareHttpRequest(apifunction, true);

        return this.http.post(request.Url, O, { withCredentials: true, headers: request.Headers })
            .toPromise()
            .then(
                res => { // Success
                    return 'sucess';
                }
            ).catch((error: HttpErrorResponse) => {
                if (error && error.status === 401) {

                    this.openDialog("500px", "Error", "Login.Error", "OK", DialogType.Error).subscribe(result => {
                        this.setLogout();
                        return false;
                    });
                } else {
                    return this.handleerror(error);
                }
            });
    }

    postElementLogout(apifunction: string, showDialogResult: boolean = true) {
        const request: HttpRequestOro = this.prepareHttpRequest(apifunction, true);

        return this.http.post(request.Url, {} , { withCredentials: true, headers: request.Headers })
            .toPromise()
            .then(
                res => { // Success
                    return res;
                }
            ).catch((error: HttpErrorResponse) => {
                return this.handleerror(error);
            });
    }

    openDialog(paramWidth: string, paramTitle: string, paramContent: string, paramYes: string, paramType: DialogType): Observable<boolean> {
        const dialogRef = this.dialog.open(MediDialogComponent, {
            width: paramWidth,
            data: { title: paramTitle, content: paramContent, yes: paramYes, no: "", type: paramType}
        });

        return dialogRef.afterClosed();
    }

    handleerror(error: HttpErrorResponse) {
        console.log("Status: ", error.status);
        if (error.status === 0 || error.status === 404) {
            this._router.navigate(['Wartung'])
                .catch((navError: unknown) => console.error('handleerror => navigate failed:', navError));
        }
        if (error.status === 503) {

        }
        if (error.status === 400) {
            // TODO Sprache
            if (error.error.message) {
                this.openDialog("500px", "Fehler", error.error.message, "OK", DialogType.Error);
            }
            else {
                this.openDialog("500px", "Fehler", error.error.Caption, "OK", DialogType.Error);
            }
        }
        if (error.status === 403) {
            this.openDialog("500px", "Fehler", error.error.Caption, "OK", DialogType.Error);
        }
        if (error.status === 500) {
            this.openDialog("500px", "Info", error.error.Caption, "OK", DialogType.Info);
        }
        return error;
    }

    prepareHttpRequest(apifunction: string, useUserService: boolean = false, jwt: string = ""): HttpRequestOro {
        let apiURL = '';
        if (useUserService) {
            apiURL = this.authServiceUrl + apifunction;
        }
        else {
            apiURL = this.baseUrl + apifunction;
        }
        console.log(apiURL);

        const language = this.cookieservice.get('lang');
        let headersnew = new HttpHeaders().append('lang', language);
        headersnew = headersnew.append('version', this.clientVersion);
        headersnew = headersnew.append('client', this.clientName);
        headersnew = headersnew.append('ApiKeyOroSchupo', this.apiKey);

        return new HttpRequestOro(apiURL, headersnew);
    }
}

